"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StaticChannelLayoutWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var StaticChannelLayoutWrapper = function StaticChannelLayoutWrapper(_ref) {
  var ChannelHeader = _ref.ChannelHeader,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat str-chat-channel static-channel team light"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__main-panel"
  }, ChannelHeader, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__list"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-auto my-[30px] mx-[25px] lg:ml-[70px] max-w-[700px]"
  }, children)))));
};
exports.StaticChannelLayoutWrapper = StaticChannelLayoutWrapper;
var _default = StaticChannelLayoutWrapper;
exports.default = _default;